import { BaseClient } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { DropdownOption } from "../../../assets/vfx/controls/components/dropdown/controlDropdown";
import { LookupDto } from "../../dto/account/lookupDto";

export class SystemClient extends BaseClient {
  routes = ["system", "Configuration"];

  async getRegionlookupQuery(): Promise<DropdownOption[]> {
    const actions: string[] = ["GetLookupValues"];
    const params: ApiParams[] = [
      new ApiParams("categoryId", "21107ba1-6255-ed11-9de2-00155d112818", true),
    ];
    const result: LookupDto[] = await this.getAsync<LookupDto[]>(
      actions,
      params
    );

    const transformedData = result?.map((region) => ({
      key: region.id as string,
      display: region.name as string,
      value: region.id as string,
    }));

    return transformedData;
  }
}
